export default "__VITE_ASSET__CKnb_W5g__"